// extracted by mini-css-extract-plugin
module.exports = {"split":"SplitPhotos_split__1zIfx","splitLeft":"SplitPhotos_splitLeft__3cD8A","splitLeftFull":"SplitPhotos_splitLeftFull__3zgB1","splitRight":"SplitPhotos_splitRight__1FI4k"};